import { translationClient } from "@app/api2/Clients";
import { useQuery } from "@tanstack/react-query";
import { Dropdown } from "@/components/bp/bp-ui";
import { useTranslation2 } from "../../Contexts/TranslationContext2";

export const BPLocaleSelector: React.FC = () => {
    const supportedLocales = useQuery({
        queryKey: ["locales"],
        queryFn: async () => {
            return await translationClient.getLocales();
        },
        gcTime: 0,
    });

    const transHelpers = useTranslation2();

    if (supportedLocales.isLoading || supportedLocales.isError) {
        return <div></div>;
    }

    return (
        <Dropdown
            value={transHelpers.currentLocale}
            onChange={(e, data) => {
                transHelpers.setLocaleAndReload(data.value as string);
            }}
            options={[
                ...supportedLocales.data?.sort((a, b) => a.name.localeCompare(b.name)).map(l => ({
                    key: l.code,
                    text: l.name,
                    value: l.code,
                })),
            ]}
        />
    );
};

